import React from 'react';
import '../../styles/CaseStudyThree/CaseStudiesResults3.css';
import productIcon1 from '../../assets/purple-money.png';
import productIcon2 from '../../assets/age.png';
import productIcon3 from '../../assets/money-purple-down.png';

const CaseStudiesResults3 = () => {
  return (
    <section className="case-results-section3">
      <div className="case-results-container3">
        {/* Title */}
        <h2 className="case-results-title3">The Results</h2>

        {/* Product/Service Boxes */}
        <div className="winning-item-container3">
          <div className="winning-item-box3">
            <img src={productIcon1} alt="Winning Item 1" className="winning-product-icon3" />
            <p>Enhanced Income Filters</p>
          </div>
          <div className="winning-item-box">
            <img src={productIcon2} alt="Winning Item 2" className="winning-product-icon3" />
            <p>Adjusted Age Targeting</p>
          </div>
          <div className="winning-item-box">
            <img src={productIcon3} alt="Winning Item 3" className="winning-product-icon3" />
            <p> Cost Per Lead Reduction</p>
          </div>
        </div>

        {/* Description Text */}
        <ul className="case-results-description3">
          <li>Excluding lower-income households resulted in a higher conversion rate among leads.</li>
          <li>Focusing on older audiences led to an improved ROI and more engaged potential customers.</li>
          <li>Overall, CPL dropped by 75%, demonstrating the effectiveness of precise audience targeting.</li>
        </ul>

      </div>
    </section>
  );
};

export default CaseStudiesResults3;